/**
 * @fileoverview GET handler for the "/engagement/campaign_iam_click_daily_stats/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignIamClickDailyStatsCampaignId } from "./constants";
import type { EngagementCampaignIamClickDailyStatsCampaignIdResult } from "./types";

export const getEngagementCampaignIamClickDailyStatsCampaignId = reactQueryFetcherAdapter(
  engagementCampaignIamClickDailyStatsCampaignId,
  (
    signal: AbortSignal,
    campaignId: string,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<EngagementCampaignIamClickDailyStatsCampaignIdResult> => {
    return fetch(
      `/engagement/campaign_iam_click_daily_stats/${campaignId}`,
      "GET",
      { app_group_id: appGroupId, start: startDate, end: endDate },
      { signal }
    );
  }
);
